import CarouselV1 from './Carousel';

export default CarouselV1;
